<script lang="ts">
  import { Container } from '@shared/ui/container';
  import { Content } from '@shared/ui/content';
  import { Heading } from '@shared/ui/heading';
  import { cn } from '@shared/utils';

  // import { XrLabel } from '@shared/ui/xr-label';
  import type { SelectionReadOneResponse } from '@entities/selection';

  import { ArtworkList } from '@widgets/artwork-list';

  export let selection: SelectionReadOneResponse;
</script>

<Heading dividePosition="none" title="{selection.title}" wrapperClass="flex-col items-start">
  <p class="text-dark-700 mb-4 mt-2 text-base">
    {selection.art_assets.length} Artwork{selection.art_assets.length !== 1 ? 's' : ''}
  </p>
  <article class="{cn('wrapper-container lg:grid lg:grid-cols-12 lg:gap-12', '!mx-0')}">
    <div class="lg:col-span-7">
      <Content blocks="{selection.description?.blocks}" />
    </div>
  </article>
</Heading>

<Container containerClass="py-8 md:py-12">
  <ArtworkList artworks="{selection.art_assets}" />
</Container>
